/** One company at a time: the picker used across the settings pages. */
import type { AdminTenant } from "../../lib/api";
import { coName } from "../../lib/brand";
import { Tile } from "../../components/bits";

export function CompanyPicker({ tenants, code, onPick, sub }: { tenants: AdminTenant[]; code: string; onPick: (c: string) => void; sub?: (t: AdminTenant) => string }) {
  return (
    <div className="ctabs" role="tablist">
      {tenants.map((x) => (
        <button key={x.code} className={`ctab ${x.code === code ? "on" : ""}`} role="tab" aria-selected={x.code === code} onClick={() => onPick(x.code)}>
          <Tile code={x.code} />
          <span>{coName(x.code, x.name)}{sub && <small>{sub(x)}</small>}</span>
        </button>
      ))}
    </div>
  );
}
